import React from 'react'
import { NavLink } from 'react-router-dom'

export const ClinicListItem = ({clinic, type}) => {
    return (
        <li>
            <NavLink to={`/patients-hospital/${clinic.id}/present/${type}`}>{clinic.description}</NavLink>
        </li>
    )
}